module.exports = __webpack_public_path__ + "static/img/img-bg-1.e6574a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-bg-1.png
// module id = qTEV
// module chunks = 0